import { Box } from '@mui/material';
import { FormCreateNewPassword } from './FormCreateNewPassword';
import background from 'assets/authentication/BackgroundResetPassword.svg';

const CreateNewPassword = () => {
    return (
        <Box
            sx={{
                background: `#182D55 url(${background}) no-repeat center`,
                backgroundSize: 'cover',
                display: 'flex',
                height: '100vh',
                overflow: 'hidden',
                width: '100vw'
            }}>
            <FormCreateNewPassword />
        </Box>
    );
};

export default CreateNewPassword;
